import { Component, DoCheck, OnInit, OnDestroy } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { animate, style, transition, trigger } from '@angular/animations';
import { GradientConfig } from '../../../../../app-config';
import { AuthorizationBusinessService } from 'src/app/business/security/authorization-business.service';
import { User } from 'src/app/model/user';
import { AppEnviroment } from 'src/app/model/app-enviroment';

import { NotificationUser } from 'src/app/model/notification-user';
import { ScreenNotificationBusinessService } from 'src/app/business/general/screen-notification-business.service';
import Swal from 'sweetalert2';
import { LicenseControlBusinessService } from 'src/app/business/general/license-control-business.service';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class NavRightComponent implements OnInit, DoCheck, OnDestroy {

  public gradientConfig: any;
  user : User;
  constructor( public business: AuthorizationBusinessService, public notifications:ScreenNotificationBusinessService, private license:LicenseControlBusinessService)
  {    
    
    this.gradientConfig = GradientConfig.config;   
    this.user = AppEnviroment.User; 
    notifications.StopNotifications();
    notifications.StartNotifications();

    license.LicenseEvent.subscribe(x=>{
      Swal.fire('Error', x, 'error');
      this.Logout();
    });
    license.StopVerification();
    license.StartVerification();
    
  }


  ngOnDestroy(): void 
  {
    
    this.Logout();
  }

  ngOnInit() {
    
  }


  ngDoCheck() {
    if (document.querySelector('body').classList.contains('elite-rtl')) {
      this.gradientConfig['rtl-layout'] = true;
    } else {
      this.gradientConfig['rtl-layout'] = false;
    }
  }

  Logout() {
    this.business.CloseSession();
    this.notifications.StopNotifications();
    this.license.StopVerification();
  }

  NotifyCheck(notify:NotificationUser)
  {
    this.notifications.CheckNotification(notify.Id).catch(x=> {
      Swal.fire('Error', x, 'error');
    });
  }
}
